import { render, staticRenderFns } from "./AllowEarningToggleButton.vue?vue&type=template&id=4381a5ec&"
import script from "./AllowEarningToggleButton.vue?vue&type=script&lang=js&"
export * from "./AllowEarningToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports